// extracted by mini-css-extract-plugin
export default {"container":"ConfirmStartTreatmentModal_container__hk9PR","buttonRow":"ConfirmStartTreatmentModal_buttonRow__oatrw","helpMessage":"ConfirmStartTreatmentModal_helpMessage__vkjBl"};